// @flow
import React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {CodeTabGroup, CodeBlock, CodeTab} from 'docs/components';
import {ContentGroupItem} from 'docs/util';
import CollapsibleJson from '../StripeClui/components/CollapsibleJson';
import {useApiExplorer} from './ApiExplorerProvider';

const messages = defineMessages({
  default: {
    id: 'docsApp.apiResponse.default',
    description: 'Default message in empty API response.',
    defaultMessage: '// No response received yet.',
  },
});

export const ApiResponse = () => {
  const {
    state: {apiResponse},
  } = useApiExplorer();
  const intl = useIntl();

  if (apiResponse?.error) {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            '',
            '',
            (
              <CodeTab key="api-response" id="api-response" title="Response">
                <CodeBlock numbered={false}>{apiResponse.error}</CodeBlock>
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_response"
      />
    );
  } else if (apiResponse?.response) {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            'json',
            'JSON',
            (
              <CodeTab key="api-response" id="api-response" title="Response">
                <CollapsibleJson data={apiResponse.response} />
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_response"
      />
    );
  } else {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            '',
            '',
            (
              <CodeTab key="api-response" id="api-response" title="Response">
                <CodeBlock>{intl.formatMessage(messages.default)}</CodeBlock>
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_response"
      />
    );
  }
};
